export const SAVED_CONNECTOR_KEY = "SAVED_CONNECTOR_KEY";
export const SAVED_CHAIN_ID = "SAVED_CHAIN_ID";
export const RPC_URL_KEY = "RPC_URL_KEY";
export const MAX_IMAGE_SIZE = 5000000;
export const LINK_REGEX =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
export const PICTURE_PER_PAGE = 12; // 一ページ当たりの画像数。
